/**
 * @license
 * Copyright (C) 2022 Anna Plodari
 * Software proprietario - Tutti i diritti riservati.
 * Registrato SIAE - Sezione OLAF.
 *
 * È vietato qualsiasi utilizzo non autorizzato, copia, modifica, estrazione,
 * riuso, rielaborazione, distribuzione, reverse engineering o decompilazione
 * del software, delle API, delle logiche applicative e dei dati del database.
 *
 * L'accesso al codice non costituisce concessione di licenza.
 */
import * as yup from 'yup';
import { SchedaTecnica } from '../../types/SchedaTecnica';

/* eslint-disable camelcase */
export const validateSchedaTecnica = (scheda_tecnica: SchedaTecnica) => {
  if (!scheda_tecnica || JSON.stringify(scheda_tecnica) === '{}') return true;

  const {
    macchine_utensili,
    rettifica,
    saldatura,
    trattamenti_galvanici,
    assemblaggio,
    montaggio,
    linguaggi_programmazione_plc,
    sistema_cnc,
    linguaggi_programmazione,
    altri_macchinari_industriali,
    strumenti_precisione,
    apparecchiature_produzione_lcd_semi,
    robot_industriali,
    dispositivi_elettronici,
    stampaggio,
    sistemi_operativi,
    strumenti_comunicazione,
    software_produttivita,
    navigazione_internet,
    gestione_database,
    grafica_multimedia,
    sviluppo_web,
    analisi_dati,
    sicurezza_informatica,
    intelligenza_artificiale,
    ingegneria,
    linguaggi_progettazione,
    impianti_elettrici,
    autotrasporto,
    cantieristica_navale,
    meccatronica_officina,
    verniciatura,
    sistemi_meccatronici,
    disegno_tecnico,
    disegno_meccanico,
  } = scheda_tecnica;

  return !(
    (macchine_utensili.centri_lavoro_cnc && macchine_utensili.centri_lavoro_cnc.length > 0) ||
    (macchine_utensili.torni.torni && macchine_utensili.torni.torni.length > 0) ||
    (macchine_utensili.fresatrici.fresatrici && macchine_utensili.fresatrici.fresatrici.length > 0) ||
    (macchine_utensili.trapani_colonna && macchine_utensili.trapani_colonna) ||
    (macchine_utensili.macchine_transfer && macchine_utensili.macchine_transfer) ||
    (macchine_utensili.macchine_maschiatrici && macchine_utensili.macchine_maschiatrici) ||
    (macchine_utensili.presse_piegatrici && macchine_utensili.presse_piegatrici) ||
    (macchine_utensili.taglio_lamiera && macchine_utensili.taglio_lamiera) ||
    (macchine_utensili.extra && macchine_utensili.extra.length > 0) ||
    (rettifica && rettifica.length > 0) ||
    (saldatura.tipi && saldatura.tipi.length > 0) ||
    (saldatura.extra && saldatura.extra.length > 0) ||
    (stampaggio?.stampaggio && stampaggio?.stampaggio.length > 0) ||
    (stampaggio?.macchine && stampaggio?.macchine.length > 0) ||
    (trattamenti_galvanici && trattamenti_galvanici.length > 0) ||
    (assemblaggio && assemblaggio.length > 0) ||
    (montaggio && montaggio.length > 0) ||
    (linguaggi_programmazione_plc && linguaggi_programmazione_plc.length > 0) ||
    (sistema_cnc.sistemi && sistema_cnc.sistemi.length > 0) ||
    (sistema_cnc.extra && sistema_cnc.extra.length > 0) ||
    (software_produttivita && sistemi_operativi.length > 0) ||
    (strumenti_comunicazione && strumenti_comunicazione.length > 0) ||
    (software_produttivita?.microsoft && software_produttivita?.microsoft.length > 0) ||
    (software_produttivita?.google && software_produttivita?.google.length > 0) ||
    (software_produttivita?.fogli_calcolo && software_produttivita?.fogli_calcolo.length > 0) ||
    (software_produttivita?.presentazioni && software_produttivita?.presentazioni.length > 0) ||
(navigazione_internet?.motori_ricerca?.tipo && navigazione_internet?.motori_ricerca?.tipo.length > 0) ||
navigazione_internet?.motori_ricerca?.extra ||
(navigazione_internet?.browser?.tipo && navigazione_internet?.browser?.tipo.length > 0) ||
navigazione_internet?.browser?.extra ||
(navigazione_internet?.email?.tipo && navigazione_internet?.email?.tipo.length > 0) ||
navigazione_internet?.email?.extra ||
    (navigazione_internet?.email.tipo && navigazione_internet?.email.tipo.length > 0) ||
    navigazione_internet?.email.extra ||
    (gestione_database?.db_no_relazionali && gestione_database?.db_no_relazionali.length > 0) ||
 (gestione_database?.db_relazionali?.tipo && gestione_database?.db_relazionali?.tipo.length > 0) ||
gestione_database?.db_relazionali?.extra ||
(gestione_database?.strumenti_gestione?.tipo && gestione_database?.strumenti_gestione?.tipo.length > 0) ||
gestione_database?.strumenti_gestione?.extra ||
    (grafica_multimedia?.grafica_multimedia && grafica_multimedia?.grafica_multimedia.length > 0) ||
(grafica_multimedia?.montaggio_video?.tipo && grafica_multimedia?.montaggio_video?.tipo.length > 0) ||
grafica_multimedia?.montaggio_video?.extra ||
    (sviluppo_web?.sviluppo_web && sviluppo_web?.sviluppo_web.length > 0) ||
    (sviluppo_web?.cms?.tipo && sviluppo_web?.cms?.tipo.length > 0) ||
sviluppo_web?.cms?.extra ||
    (analisi_dati?.linguaggi_analisi && analisi_dati?.linguaggi_analisi.length > 0) ||
   (analisi_dati?.strumenti_analisi?.tipo && analisi_dati?.strumenti_analisi?.tipo.length > 0) ||
analisi_dati?.strumenti_analisi?.extra ||
    (ingegneria?.tipo && ingegneria?.tipo.length > 0) ||
    ingegneria?.extra ||
    (linguaggi_progettazione?.linguaggi && linguaggi_progettazione.linguaggi.length > 0) ||
    linguaggi_progettazione?.extra ||
    (linguaggi_programmazione?.linguaggi && linguaggi_programmazione?.linguaggi.length > 0) ||
    linguaggi_programmazione.extra ||
    (sistema_cnc.extra && sistema_cnc.extra.length > 0) ||
    (linguaggi_programmazione?.linguaggi && linguaggi_programmazione?.linguaggi.length > 0) ||
    (linguaggi_programmazione?.extra && linguaggi_programmazione?.extra.length > 0) ||
    (sicurezza_informatica && sicurezza_informatica.length > 0) ||
    (intelligenza_artificiale?.intelligenza_artificiale &&
      intelligenza_artificiale?.intelligenza_artificiale.length > 0) ||
    (intelligenza_artificiale.extra && intelligenza_artificiale.extra.length > 0) ||
    (impianti_elettrici?.impianti_elettrici && impianti_elettrici?.impianti_elettrici.length > 0) ||
    (impianti_elettrici?.competenze && impianti_elettrici?.competenze.length > 0) ||
    (impianti_elettrici?.attestato && impianti_elettrici?.attestato.length > 0) ||
    (autotrasporto?.autotrasporto && autotrasporto?.autotrasporto.length > 0) ||
    (autotrasporto?.tipo_patente && autotrasporto?.tipo_patente.length > 0) ||
    (autotrasporto?.tipo_merci && autotrasporto?.tipo_merci.length > 0) ||
   (autotrasporto?.tipo_veicoli?.tipo_veicoli?.tipo && autotrasporto?.tipo_veicoli?.tipo_veicoli?.tipo.length > 0) ||
autotrasporto?.tipo_veicoli?.tipo_veicoli?.extra ||
    (autotrasporto?.tipo_veicoli.categoria && autotrasporto?.tipo_veicoli.categoria.length > 0) ||
   (cantieristica_navale?.cantieristica_navale?.tipo && cantieristica_navale?.cantieristica_navale?.tipo.length > 0) ||
cantieristica_navale?.cantieristica_navale?.extra ||
    (cantieristica_navale?.tipologia && cantieristica_navale?.tipologia.length > 0) ||
    (cantieristica_navale?.classificazione && cantieristica_navale?.classificazione.length > 0) ||
    (meccatronica_officina?.meccatronica_officina && meccatronica_officina?.meccatronica_officina.length > 0) ||
    (meccatronica_officina?.competenze && meccatronica_officina?.competenze.length > 0) ||
    (sistemi_meccatronici?.sistemi && sistemi_meccatronici?.sistemi.length > 0) ||
    sistemi_meccatronici?.extra ||
    (disegno_tecnico?.tipo && disegno_tecnico.tipo.length > 0) ||
    disegno_tecnico?.extra ||
    (disegno_meccanico?.tipo && disegno_meccanico.tipo.length > 0) ||
    disegno_meccanico?.extra ||
    (verniciatura?.verniciatura && verniciatura?.verniciatura.length > 0) ||
    verniciatura?.extra ||
    (altri_macchinari_industriali && altri_macchinari_industriali.length > 0) ||
    (strumenti_precisione && strumenti_precisione.length > 0) ||
    (apparecchiature_produzione_lcd_semi && apparecchiature_produzione_lcd_semi.length > 0) ||
    (robot_industriali && robot_industriali.length > 0) ||
    (dispositivi_elettronici && dispositivi_elettronici.length > 0)
  );
};

export const checkTruthyOrNotEmpty = (obj: any): boolean => {
  if (typeof obj === 'object' && obj !== null) {
    // eslint-disable-next-line no-restricted-syntax
    for (const key in obj) {
      if (checkTruthyOrNotEmpty(obj[key])) {
        return true;
      }
    }
  } else {
    return obj === true || (typeof obj === 'string' && obj !== '');
  }
  return false;
};

export const regexBlocked = {
  email: /@|[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i,
  phone: /\+?\d{6,15}/,
  address: /\b(?:via|viale|piazza|strada|corso|contrada|vicolo)\s+[a-zàèìòù]+/i,
};

export const validateExtraField = () =>
  yup
    .string()
    .trim()
    .test("no-email", "Non puoi inserire l'email", (val) => !val || !regexBlocked.email.test(val))
    .test("no-phone", "Non puoi inserireun  numero di telefono", (val) => !val || !regexBlocked.phone.test(val))
    .test("no-address", "Non puoi inserire un indirizzo", (val) => !val || !regexBlocked.address.test(val));
